import React from 'react';
import { MarketingSubtitle } from '../../Subtitles/MarketingSubtitle';
import { Alert } from '../../Alert/Alert';
import { ContentType, ErrorType } from '../../../content';
import { InlineProgress } from '../../Progress/InlineProgress';

export type CardVariant = 'default' | 'modal' | 'none';

export const NoCard = ({
  error,
  ready,
  contentType,
}: {
  error?: ErrorType;
  ready?: boolean;
  contentType: ContentType;
}) => (
  <>
    <MarketingSubtitle contentType={contentType} />
    {!error && !ready && <InlineProgress contentType={contentType} loadingColor="white" />}
    {error && <Alert contentType={contentType} errorKey={error} />}
  </>
);
